import { Car } from '@/types/car.type.ts';

export function getCarFullName(car: Car): string {
    const carModelName = car.model_code?.model_code
        ? `${car.model.name} ${car.model_code?.model_code}`
        : car.model.name;

    return `${car.brand.name} ${carModelName}, ${car.production_year}`;
}
